import { useParams } from 'react-router-dom';
import { useApplicationDetail } from '@axo/shared/data-access/hooks';
import { ApplicationSelect } from './ApplicationSelect';
import styles from './ApplicationActionBar.module.css';
import { RefreshApplicationButton } from './RefreshApplicationButton';
import { GoToMyPageButton } from './GoToMyPageButton';
import { SetProcessedButton } from './SetProcessedButton';
import { ArchiveButton } from './ArchiveButton';
import { CloneApplicationButton } from './CloneApplicationButton';
import { loan_application, permissions } from '@axo/shared/data-access/types';
import { MarkAsDuplicateButton } from './MarkAsDuplicateButton';
import { ClawbackApplicationButton } from './ClawbackApplicationButton';
import { Button, Menu, Popover } from '@blueprintjs/core';
import { Restricted } from '@axo/shared/feature/restricted';
import { CustomerWithdrawnButton } from './CustomerWithdrawnButton';
import { CancelAllOffers } from './CancelAllOffers';
import { MarkAsFraudButton } from './MarkAsFraudButton';

export function ApplicationActionBar() {
  const { applicationID } = useParams();
  if (!applicationID) throw new Error(`Missing param "applicationID"`);
  const app = useApplicationDetail(applicationID);

  return (
    <div className={styles.actionBar}>
      <ApplicationSelect applicationID={applicationID} />
      {app.data ? (
        <div className={styles.actions}>
          <Restricted
            isAllowedFor={[
              permissions.RoleName.Manager,
              permissions.RoleName.Sales,
              permissions.RoleName.SecuredSales,
            ]}
          >
            <SetProcessedButton
              marketCountry={app.data.MarketCountry}
              applicationID={app.data.ID}
              isSecuredLoan={app.data.Product === loan_application.Product.SecuredLoan}
            />
          </Restricted>
          <Restricted
            isAllowedFor={[
              permissions.RoleName.Manager,
              permissions.RoleName.SecuredSales,
              permissions.RoleName.Sales,
              permissions.RoleName.Telemarketing,
            ]}
          >
            {app.data.Status ===
              loan_application.ApplicationStatus
                .ApplicationStatusApplicationReviewManualAdjustment && (
              <MarkAsDuplicateButton
                applicationID={app.data.ID}
                marketCountry={app.data.MarketCountry}
              />
            )}
          </Restricted>
          <Restricted
            isAllowedFor={[
              permissions.RoleName.Manager,
              permissions.RoleName.Sales,
              permissions.RoleName.SecuredSales,
              permissions.RoleName.Telemarketing,
            ]}
          >
            <CloneApplicationButton applicationID={app.data.ID} />
          </Restricted>
          <GoToMyPageButton
            applicationID={app.data.ID}
            brand={app.data.Meta?.Brand}
          />
          <Restricted
            isAllowedFor={[
              permissions.RoleName.Manager,
              permissions.RoleName.Sales,
              permissions.RoleName.SecuredSales,
              permissions.RoleName.Telemarketing,
            ]}
          >
            <ArchiveButton applicationID={app.data.ID} />
          </Restricted>
          <RefreshApplicationButton
            applicationID={app.data.ID}
            customerID={app.data.CustomerID}
            personID={app.data.PersonID}
          />

          <Popover
            interactionKind="hover"
            content={
              <Menu>
                <Restricted
                  isAllowedFor={[
                    permissions.RoleName.Manager,
                    permissions.RoleName.SecuredSales,
                    permissions.RoleName.Sales,
                    permissions.RoleName.Telemarketing,
                  ]}
                >
                  <CustomerWithdrawnButton applicationID={app.data.ID} />
                </Restricted>
                <Restricted isAllowedFor={[permissions.RoleName.Manager]}>
                  <ClawbackApplicationButton applicationID={app.data.ID} />
                </Restricted>
                <CancelAllOffers
                  marketCountry={app.data.MarketCountry}
                  applicationID={app.data.ID}
                  cancelledBy="Axo"
                />
                <CancelAllOffers
                  marketCountry={app.data.MarketCountry}
                  applicationID={app.data.ID}
                  cancelledBy="Customer"
                />
                <Restricted isAllowedFor={[permissions.RoleName.Manager]}>
                  <MarkAsFraudButton
                    applicationID={app.data.ID}
                    personID={app.data.PersonID}
                  />
                </Restricted>
              </Menu>
            }
            placement="bottom-start"
          >
            <Button icon="menu" />
          </Popover>
        </div>
      ) : null}
    </div>
  );
}
